/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:7b19ddd5-e4e4-464e-9549-1bbb03b43ca6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ZmD0oksiq",
    "aws_user_pools_web_client_id": "7s44f7i1ll6rbncvg8u7vk9ro0",
    "oauth": {
        "scope": [
            "aws.cognito.signin.user.admin",
            "openid",
            "profile"
        ],
        "redirectSignIn": "https://dashboards.los.lenderscooperative.com",
        "redirectSignOut": "https://dashboards.los.lenderscooperative.com",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": []
};


export default awsmobile;
